function handleShowMoreClick(event) {
  const button = event.target.closest('show-more-button button, button.button-show-more');
  if (!button) return;
  event.preventDefault();
  const parentDisplay = button.closest('.parent-display, .mobile-facets__submenu');
  if (!parentDisplay) return;
  const showMoreEl = button.closest('show-more-button');
  if (showMoreEl) showMoreEl.querySelectorAll('.label-text').forEach((el) => el.classList.toggle('hidden'));
  parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
  const nextElementToFocus = parentDisplay.querySelector('.show-more-item:not(.hidden) input');
  if (nextElementToFocus) nextElementToFocus.focus();
}

document.addEventListener('click', handleShowMoreClick, true);

class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('show-more-button', ShowMoreButton);

